import React from 'react';
import { UserCheck, Calendar } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

const CppRequirements = () => {
  const { language } = useLanguage();

  return (
    <section className="cpp-section">
      <div className="cpp-container">
        <div className="cpp-card">
          <h2 className="cpp-heading-2 text-white mb-8 text-center flex items-center justify-center gap-3">
            <UserCheck className="w-8 h-8 text-blue-400" />
            {language === 'ar' ? 'متطلبات الالتحاق' : 'Enrollment Requirements'}
          </h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-blue-900/20 p-6 rounded-xl border border-blue-500/30">
              <div className="flex items-center gap-3 mb-4">
                <UserCheck className="w-6 h-6 text-blue-400" />
                <h3 className="cpp-heading-3 text-white">
                  {language === 'ar' ? 'الجنس' : 'Gender'}
                </h3>
              </div>
              <p className="text-blue-400 font-semibold text-lg">
                {language === 'ar' ? '🚹 للذكور فقط' : '🚹 Males Only'}
              </p>
            </div>
            
            <div className="bg-purple-900/20 p-6 rounded-xl border border-purple-500/30">
              <div className="flex items-center gap-3 mb-4">
                <Calendar className="w-6 h-6 text-purple-400" />
                <h3 className="cpp-heading-3 text-white">
                  {language === 'ar' ? 'العمر المطلوب' : 'Age Requirement'}
                </h3>
              </div>
              <p className="text-purple-400 font-semibold text-lg">
                {language === 'ar' ? '📅 16 سنة فأكثر' : '📅 16 Years and Above'}
              </p>
            </div>
          </div>
          
          {/* Important Notice */}
          <div className="mt-6 p-4 bg-yellow-900/20 border border-yellow-500/30 rounded-xl">
            <p className="text-center text-yellow-400 font-medium">
              <strong>
                {language === 'ar' 
                  ? '📋 يرجى التأكد من استيفاء هذه المتطلبات قبل التسجيل'
                  : '📋 Please ensure you meet these requirements before enrolling'
                }
              </strong>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CppRequirements;